export const CLEANUP_BUSINESS = 'CLEANUP_BUSINESS'
export const FETCH_BUSINESS_INIT = 'FETCH_BUSINESS_INIT'
export const FETCH_BUSINESS_SUCCESS = 'FETCH_BUSINESS_SUCCESS'
export const FETCH_BUSINESS_FAIL = 'FETCH_BUSINESS_FAIL'
export const UPDATE_BUSINESS_COMPANY_INFO = 'UPDATE_BUSINESS_COMPANY_INFO'
export const UPDATE_BUSINESS_NAME = 'UPDATE_BUSINESS_NAME'
export const UPDATE_ACCOUNT_NAME = 'UPDATE_ACCOUNT_NAME'
export const UPDATE_BUSINESS_KEYWORDS = 'UPDATE_BUSINESS_KEYWORDS'
export const UPDATE_BUSINESS_BUDGET = 'UPDATE_BUSINESS_BUDGET'
